import React from 'react';

const FeaturesContext = React.createContext({
  features: null,
});

FeaturesContext.displayName = 'FeaturesContext';

export default FeaturesContext;
